import type { FormFieldConfig } from "@checkout-v2/formFields";

export type ToggleFieldConfig<Name extends string = string, Data = object> = FormFieldConfig<Name, Data>;
